<app-draggable-modal-wrapper>
    <h2
        mat-dialog-title
        modal-drag-handle
        class="!text-2xl !font-normal !text-primary-700 !mb-2"
    >
        Delete Credit Card
    </h2>
    <hr />
    <mat-dialog-content class="ps-6 pt-4 mat-typography">
        @if (displayInfo) {
            <p class="text-sm text-gray-600 mb-4">
                Are you sure you want to delete the following card? This action
                cannot be undone.
            </p>
            <div
                class="flex flex-col divide-y divide-gray-200 border border-solid border-gray-200 rounded-lg overflow-hidden"
            >
                <div class="flex items-center px-4 py-3 gap-4">
                    <span
                        class="text-xs font-medium text-gray-500 uppercase tracking-wider w-32 shrink-0"
                        >Cardholder</span
                    >
                    <span
                        class="text-sm font-semibold text-gray-800 min-w-0 break-words"
                        >{{ displayInfo.firstName }}
                        {{ displayInfo.lastName }}</span
                    >
                </div>
                <div class="flex items-center px-4 py-3 gap-4">
                    <span
                        class="text-xs font-medium text-gray-500 uppercase tracking-wider w-32 shrink-0"
                        >Card Type</span
                    >
                    <span class="text-sm font-semibold text-gray-800">{{
                        cardTypeLabelMapping[displayInfo.cardType]
                    }}</span>
                </div>
                <div class="flex items-center px-4 py-3 gap-4">
                    <span
                        class="text-xs font-medium text-gray-500 uppercase tracking-wider w-32 shrink-0"
                        >Card Number</span
                    >
                    <span
                        class="text-sm font-semibold text-gray-800 flex items-center gap-2"
                    >
                        Ending in {{ displayInfo.truncatedCardNumber }}
                        <app-card-type-icon
                            class="ml-1"
                            [cardType]="displayInfo.cardType"
                        />
                    </span>
                </div>
                <div class="flex items-center px-4 py-3 gap-4">
                    <span
                        class="text-xs font-medium text-gray-500 uppercase tracking-wider w-32 shrink-0"
                        >Expiration</span
                    >
                    <span class="text-sm font-semibold text-gray-800"
                        >{{ displayInfo.expirationMonth }}/{{
                            displayInfo.expirationYear
                        }}</span
                    >
                </div>
            </div>
        }
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="!pb-5 !pr-5">
        <button
            type="button"
            mat-stroked-button
            color="primary"
            class="!border-primary-700"
            (click)="onCancel()"
        >
            Cancel
        </button>
        <button
            mat-raised-button
            type="button"
            name="Delete"
            cdkFocusInitial
            color="primary"
            (click)="onSubmit()"
        >
            Delete
        </button>
    </mat-dialog-actions>
</app-draggable-modal-wrapper>
